import { makeAutoObservable, runInAction, toJS } from 'mobx';

export class ArticlesStore {
  searchElement = null;

  searchInput = null;

  resultObject = null;

  checkBoxObject = {
    highlyCheck: false,
    priorityCheck: false,
  };

  filters = {
    year: null,
    status: null,
  };

  allArticles = null;

  constructor() {
    makeAutoObservable(this);
  }

  changeFilter(name, value) {
    const changePromise = new Promise(((resolve) => {
      runInAction(() => {
        this.filters[name] = value !== 'null' ? value : null;
        resolve();
      });
    }));
    return changePromise;
  }

  clearFilters() {
    for (let filter in this.filters) {
      filter = null;
    }
  }

  clearStoreOnCardExit() {
    this.searchElement = null;
    this.searchInput = null;
    this.checkBoxObject = {
      highlyCheck: false,
      priorityCheck: false,
    };
    this.resultObject = null;
  }

  clearAllStore() {
    this.clearStoreOnCardExit();
    this.allArticles = null;
    this.filters = {
      year: null,
      status: null,

    };
  }

  updateAllArticles(articles) {
    this.allArticles = articles;
  }

  setSearchElement(newElement) {
    this.searchElement = newElement;
  }

  clearSearchElement() {
    this.searchElement = null;
  }

  setSearchInput(str) {
    this.searchInput = str;
  }

  setResultObject(obj) {
    this.resultObject = {
      ...{
        highlyCitedPaper: false,
        isPriorityFinSource: false,
      },
      ...obj,
    };
    this.resultObject.file = !!this.resultObject.file && [this.resultObject?.file];
  }

  updateResultObject(...args) {
    const [value, propertyName] = args;
    if (propertyName === 'file') {
      const a = [...value];
      this.resultObject = { ...this.resultObject, [propertyName]: a };
    } else { this.resultObject = { ...this.resultObject, [propertyName]: value }; }
  }

  clearCheckBoxResult() {
    this.checkBoxObject = {
      highlyCheck: false,
      priorityCheck: false,
    };
  }

  setCheckBoxResult(property, value) {
    if (toJS(this.checkBoxObject).hasOwnProperty(property)) {
      this.checkBoxObject[property] = value;
    } else throw new Error(`${property} is not exist in ${this.checkBoxObject}`);
  }
}
